import { TranslationsEn } from '~/locales/translationEn';
import { TranslationsMx } from '~/locales/translationMx';
import { TranslationsZh } from '~/locales/translationZh';
import { createTranslationKeysWithType, translate as translateWith, useMagicLocalization } from './magicLocalization';

export const translations = {
  en: TranslationsEn,
  mx: TranslationsMx,
  es: TranslationsMx,
  zh: TranslationsZh,
} as const;

const { keys, type: _type } = createTranslationKeysWithType(translations);
export const useLocalization = () => useMagicLocalization(translations);
export const translate = (key: TranslationKeys, language: string, params: Record<string, unknown> = {}): string =>
  translateWith(translations, language, key, params);
export const TranslationKeys = keys;
export type TranslationKeys = typeof _type;
